document.addEventListener("DOMContentLoaded", function () {
  // Initialize Swiper
  const swiper = new Swiper('.product-image_slide-accordion_info-section .swiper-container', {
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    loop: false,
    speed: 700,
    // 画像ごとに縦横比が違っても、表示中の画像の高さに箱を合わせる。
    // 画像の下に余白を作らず、左右の矢印を画像の上下中央に置くため。
    autoHeight: true,
  });

  // Accordion functionality
  const accordionButtons = document.querySelectorAll('.accordion-button');
  accordionButtons.forEach(button => {
    button.addEventListener('click', function () {
      const content = this.nextElementSibling;
      if (content.classList.contains('open')) {
        // Close action
        content.classList.remove('open');
        this.classList.remove('open');
      } else {
        // Open action
        content.classList.add('open');
        this.classList.add('open');
      }
    });
  });
});
